import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
    container: {
        padding: theme.spacing(4),
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(2)
        }
    },
    title: {
        fontSize: 28,
        [theme.breakpoints.down('sm')]: {
            fontSize: 22
        }
    },
    subtitle: {
        fontSize: 16,
        color: 'var(--foreground-black-60-opacity)',
        marginTop: theme.spacing(1)
    },
    cardWrapper: {
        position: 'relative',
        paddingTop: '100%'
    },
    card: {
        position: 'absolute',
        inset: 0,
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: 'var(--background-white)',
        border: `1px solid ${theme.palette.fg.silver}`,
        borderRadius: 'var(--border-radius-mini)',
        overflow: 'hidden',
        '&:hover': {
            transition: 'all 0.3s ease',
            border: `1px solid ${theme.palette.fg.black}`
        }
    },
    cardCta: {
        backgroundColor: 'var(--background-purple-light-extra)'
    },
    cardContent: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        padding: theme.spacing(2.5),
        boxSizing: 'border-box',
        '&:last-child': {
            paddingBottom: theme.spacing(2.5)
        }
    },
    cardCtaContent: {
        justifyContent: 'center',
        alignItems: 'center',
        gap: theme.spacing(1.5)
    },
    logoAndName: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1.5),
        marginBottom: theme.spacing(2)
    },
    logo: {
        width: 50,
        height: 50,
        flexShrink: 0,
        border: `1px solid ${theme.palette.fg.silver}`,
        borderRadius: 'var(--border-radius-mini)',
        overflow: 'hidden',
        display: 'block',
        objectFit: 'cover',
        [theme.breakpoints.up('xl')]: {
            width: 100,
            height: 100
        }
    },
    integrationName: {
        fontSize: 20,
        lineHeight: 1.3,
        flexGrow: 1
    },
    description: {
        fontSize: 15,
        color: 'var(--foreground-black-60-opacity)',
        flexGrow: 1,
        marginBottom: theme.spacing(1.5),
        overflow: 'hidden',
        display: '-webkit-box',
        '-webkit-line-clamp': 4,
        '-webkit-box-orient': 'vertical'
    },
    ctaTitle: {
        fontSize: 20,
        textAlign: 'center'
    },
    ctaSubtitle: {
        fontSize: 16,
        color: 'var(--foreground-black-60-opacity)',
        textAlign: 'center',
        marginBottom: theme.spacing(2)
    },
    buttonBox: {
        marginTop: 'auto'
    },
    ctaButtonBox: {
        display: 'flex',
        justifyContent: 'center'
    },
    button: {
        width: '100%',
        boxSizing: 'border-box',
        borderRadius: 'var(--border-radius-mini)'
    },
    ctaButton: {
        borderRadius: 'var(--border-radius-mini)'
    },
    sidebar: {
        [theme.breakpoints.up('md')]: {
            position: 'sticky',
            top: theme.spacing(3)
        }
    },
    apiDocsRow: {
        marginTop: theme.spacing(4)
    },
    apiDocsLink: {
        fontWeight: 'bold',
        display: 'inline-flex',
        alignItems: 'center',
        gap: 8,
        color: 'var(--foreground-purple)',
        fontSize: 16,
        textDecoration: 'none',
        '&:hover': {
            color: 'black',
            textDecoration: 'none'
        }
    }
}))
